import { gql, useLazyQuery } from "@apollo/client";
import { SCORING_CLIENT } from "@/utils/consts";
import type { ScoringType } from "@/lib/scoring/types";

const GENERATE_SCORING_PROFILE = gql`
  query GenerateScoringProfile($productIds: [Int], $companiesFilter: Json) {
    generatedScoring(
      productIds: $productIds
      companiesFilter: $companiesFilter
    ) {
      parameters {
        criteria {
          ... on ProductsCriteria {
            name
            wasGenerated
            products {
              ids
              inclusionMethod
              score
            }
          }
          ... on RevenueCriteria {
            name
            wasGenerated
            revenue {
              min
              max
              score
            }
          }
          ... on EmployeesCriteria {
            name
            wasGenerated
            employees {
              min
              max
              score
            }
          }
          ... on GeographyCriteria {
            name
            wasGenerated
            geography {
              countryAlpha2s
              score
            }
          }
          ... on IndustryCriteria {
            name
            wasGenerated
            industry {
              industryIds
              score
            }
          }
        }
      }
    }
  }
`;

export interface GeneratedScoringResponse {
  generatedScoring: {
    parameters: {
      criteria: ScoringType[];
    };
  };
}

export function useGenerateScoringProfile() {
  return useLazyQuery<GeneratedScoringResponse>(GENERATE_SCORING_PROFILE, {
    context: { clientName: SCORING_CLIENT },
    fetchPolicy: "no-cache",
  });
}
